// kitchen order list

import kitchen from '@/api/restaurant-sale/kdu'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState
}

export const getters = {
		// get table has been order
    getTableOrder: state => {
        return _.uniqBy(state.resources, 'table_id')
		},
		//ge unique product to show on dish view 
		getUniqProduct: state => {
			return _.uniqBy(state.resources, 'product_id')
			
		},
		// get unique table by product id
		getUniqTable: state => ({ productId }) => {
			let table = state.resources.filter(r => r.product_id == productId)
			return _.uniqBy(table, 'table_id')
		},
		// get uom unique by product id to show in dish view 
		getUom: state => ({ productId }) => {
			if(productId){
				let uom = state.resources.filter(r => r.product_id == productId)
				return _.uniqBy(uom, 'uom_id')
			}
		},
		// count number of uom order on each product
		numUom: state => ({ productId, uomId }) => {
			if(productId && uomId){
				var num = state.resources.filter(r => r.product_id == productId && r.uom_id == uomId)
				return _.sumBy(num, 'quantity')
			}
		}
}

export const mutations = {
	...baseMutations,
	SET_STATUS_COMPLETE(state, data){
		state.resources.filter(
			r => r.stock_out_id == data.stock_out_id && r.product_id == data.product_id && r.uom_id == data.uom_id
		).forEach(element => {
			element.cooking_status_id = 3	
		});
	}
}

export const actions = {
  fetch(context, attrubutes = {}) {
		let params = Object.assign(
      attrubutes
		)
		
    return kitchen.orderList({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
	},
	update(context, { id, data}){
		return kitchen.update(id, data)
	},
	getGroup(context){
		return kitchen.group()
	}
}